module["exports"] = [
  "#{Address.city} #{suffix}"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/sv/team/name.js
// module id = 1629
// module chunks = 0